import axios from 'axios';
import https from 'https';

const apiAxio = axios.create({
  
  baseURL: process.env.REACT_APP_API_URL || 'https://api-production-4f9e.up.railway.app',
  httpsAgent: new https.Agent({
    rejectUnauthorized: false // Ignora a verificação do certificado SSL
  }),
  headers: {
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE,PATCH,OPTIONS'
  }
});

class Api {
  // eslint-disable-next-line class-methods-use-this
  async get(url, token) {
    try {
      const headers = {};
      headers.Accept = 'application/json';
      headers.Authorization = ` Bearer ${token}`;

      return apiAxio.get(url, { headers });
    } catch (e) {
      console.error('api (ERROR): ', e);
      return false;
    }
  }

  // eslint-disable-next-line class-methods-use-this
  async post(url, param, token) {
    try {
      const headers = {};
      headers['Content-Type'] = 'application/json';
      headers.Accept = 'application/json';
      headers.Authorization = ` Bearer ${token}`;

      return apiAxio.post(url, param, { headers });
    } catch (e) {
      console.error('api (ERROR): ', e);
      return false;
    }
  }

  // eslint-disable-next-line class-methods-use-this
  async postFile(url, body, token, noTimeout) {
    try {
      if (noTimeout === true) {
        apiAxio.defaults.timeout = 1000 * 60 * 60; // 60 segundos * 60 minutos = 1 hora
      } else {
        apiAxio.defaults.timeout = 1000 * 60 * 1; // 60 segundos * 1 minutos = 1 minuto
      }

      const headers = {};
      headers['Content-Type'] = 'multipart/form-data';
      headers.Accept = 'application/json';
      headers.Authorization = ` Bearer ${token}`;

      return apiAxio.post(url, body, { headers });
    } catch (e) {
      console.error('api (ERROR): ', e);
      return false;
    }
  }

  // eslint-disable-next-line class-methods-use-this
  async put(url, param, token) {
    try {
      const headers = {};
      headers['Content-Type'] = 'application/json';
      headers.Accept = 'application/json';
      headers.Authorization = ` Bearer ${token}`;

      return apiAxio.put(url, param, { headers });
    } catch (e) {
      console.error('api (ERROR): ', e);
      return false;
    }
  }

  // eslint-disable-next-line class-methods-use-this
  async putFile(url, body, token, noTimeout) {
    try {
      if (noTimeout === true) {
        apiAxio.defaults.timeout = 1000 * 60 * 60; // 60 segundos * 60 minutos = 1 hora
      } else {
        apiAxio.defaults.timeout = 1000 * 60 * 1; // 60 segundos * 1 minutos = 1 minuto
      }

      const headers = {};
      headers['Content-Type'] = 'multipart/form-data';
      headers.Accept = 'application/json';
      headers.Authorization = ` Bearer ${token}`;

      return apiAxio.put(url, body, { headers });
    } catch (e) {
      console.error('api (ERROR): ', e);
      return false;
    }
  }

  // eslint-disable-next-line class-methods-use-this
  async delete(url, token) {
    try {
      const headers = {};
      headers.Accept = 'application/json';
      headers.Authorization = ` Bearer ${token}`;

      return apiAxio.delete(url, { headers });
    } catch (e) {
      console.error('api (ERROR): ', e);
      return false;
    }
  }

  // eslint-disable-next-line class-methods-use-this
  async patch(url, param, token) {
    try {
      const headers = {};
      headers['Content-Type'] = 'application/json';
      headers.Accept = 'application/json';
      headers.Authorization = ` Bearer ${token}`;

      return apiAxio.patch(url, param, { headers });
    } catch (e) {
      console.error('api (ERROR): ', e);
      return false;
    }
  }
}

export default Api;
